export const PLAY_SLIP_EDITOR_ID = 'play-slip-editor'
